import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrLabel } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import { Radio } from "@mui/material";
import classNames from "classnames";
const radioColor = (color) => {
    const colors = {
        primary: palette["maven-blue-dark"],
        gray: palette.grey080,
        orange: palette.orange050,
        red: palette.red060,
        green: palette.green060,
        purple: palette.purple060,
        navy: palette.darkNavy050,
    };
    return colors[color !== null && color !== void 0 ? color : "primary"];
};
const StyledRadio = styled(Radio)(props => ({
    ".MuiSvgIcon-root": {
        width: (props.size === "large" && "20px") || "16px",
        height: (props.size === "large" && "20px") || "16px",
        path: {
            fill: ((props.disabled || props.readOnly) && palette.grey030) || (props.checked && radioColor(props.radioColor)) || palette.grey040,
        },
    },
    padding: "0",
    margin: "0",
    ...props.style,
}));
export function GrRadio({ size, readOnly, disabled, label, className, color, ...props }) {
    var _a, _b, _c, _d, _e;
    const htmlFor = (_a = label === null || label === void 0 ? void 0 : label.htmlFor) !== null && _a !== void 0 ? _a : props.id;
    return (_jsxs(GrStack, { className: "GrRadio-wrapper", display: "inline-flex", flexDirection: (_b = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _b !== void 0 ? _b : "row", gap: (_c = label === null || label === void 0 ? void 0 : label.gap) !== null && _c !== void 0 ? _c : "6px", alignItems: ((_d = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _d === void 0 ? void 0 : _d.includes("column")) ? "flex-start" : "center", style: { position: "relative" }, children: [_jsx(GrStack, { width: size === "large" ? 16 : 12, height: size === "large" ? 16 : 12, backgroundColor: "white", style: { borderRadius: "50%", position: "absolute", left: 2 } }), _jsx(StyledRadio, { className: classNames("GrRadio", className), size: size, readOnly: readOnly, disabled: disabled, value: props.value, radioColor: color, ...props }), (label === null || label === void 0 ? void 0 : label.text) && (_jsx(GrLabel, { ...label, htmlFor: htmlFor, style: {
                    marginTop: ((_e = label.flexDirection) === null || _e === void 0 ? void 0 : _e.includes("column")) ? (size === "large" ? "17px" : "13px") : 0,
                    fontSize: size === "large" ? "16px" : "14px",
                    fontWeight: 400,
                    padding: "0 2px",
                    color: (disabled && palette.grey030) || (readOnly && palette.grey060) || palette.grey090,
                    cursor: props.id && props.id === htmlFor ? "pointer" : "default",
                    ...label.style,
                } }))] }));
}
//# sourceMappingURL=GrRadio.js.map